export * from './model';

import type { CreditsEditorComponentProps } from './CreditsEditorComponent';

export const CreditsEditorComponent = {
    MountAsync: async (target: HTMLElement, props: CreditsEditorComponentProps) => {
        const { mountReactComponentAsync } = await import('@/utils/mountReactComponentAsync');
        const { CreditsEditorComponent } = await import('./CreditsEditorComponent');

        const showSubscriptions: (() => void)[] = [];

        const show = () => {
            showSubscriptions.forEach(subscription => subscription());
        };

        props = {
            ...props,
            showSubscriptions: showSubscriptions,
        };

        await mountReactComponentAsync(target, CreditsEditorComponent, props);

        return { show };
    }
};